/**
 * 요건 배지 — 관세율표 상세 격자(HeadingGrid)와 같은 값(문의 #23): 배경 회색 통일, 유형은 글자 색으로
 * (세관장확인=빨강·통합공고=파랑·기타=회색), 방향은 Im/Ex 글자로만. 유형은 `GET /api/onto/req-customs?hs4=`(fail-open).
 */
import React, { useEffect, useState } from "react"; // eslint-disable-line no-unused-vars

export const REQ_TYPE_LABEL = { customs: "세관장확인", notice: "통합공고" };
const base = { display: "inline-block", fontSize: 11, fontWeight: 700, lineHeight: "14px", padding: "1px 6px", borderRadius: 2, background: "#eceef1", letterSpacing: "0.2px", border: "none", fontFamily: "inherit", cursor: "pointer" };
export function reqBadgeStyle(type) {
  return { ...base, color: type === "customs" ? "#c0392b" : type === "notice" ? "#1d4ed8" : "#4b5563" };
}
export function reqBadgeTitle(dir, type) {
  const kind = REQ_TYPE_LABEL[type];
  return `${dir}요건${kind ? "(" + kind + ")" : ""} — 클릭 시 법령·승인기관·적용기간`;
}

/** 호 여러 개의 세관장확인 유형 플래그 { [hsk]: { im, ex } } — 실패하면 빈 객체(배지는 회색으로). */
export function useReqCustoms(hs4s, fetchImpl) {
  const key = (hs4s || []).filter((h) => /^[0-9]{4}$/.test(String(h))).join(",");
  const [flags, setFlags] = useState({});
  useEffect(() => {
    if (!key) { setFlags({}); return undefined; }
    const f = fetchImpl || (typeof fetch === "function" ? fetch : null);
    if (!f) return undefined;
    let alive = true;
    Promise.all(key.split(",").map((hs4) => Promise.resolve().then(() => f(`/api/onto/req-customs?hs4=${hs4}`)).then((r) => (r && r.ok ? r.json() : null)).catch(() => null)))
      .then((list) => { if (!alive) return; const merged = {}; list.forEach((d) => { if (d && d.flags) Object.assign(merged, d.flags); }); setFlags(merged); });
    return () => { alive = false; };
  }, [key, fetchImpl]);
  return flags;
}

/** Im/Ex 배지 — 누르면 onOpen(hsk). */
export function ReqBadges({ hsk, hasImport, hasExport, flags, onOpen }) {
  if (!hasImport && !hasExport) return null;
  const f = (flags && flags[hsk]) || {};
  return (
    <span data-testid="req-badges" style={{ display: "inline-flex", gap: 3, justifyContent: "center" }}>
      {hasImport && <button type="button" style={reqBadgeStyle(f.im)} title={reqBadgeTitle("수입", f.im)} onClick={(e) => { e.stopPropagation(); onOpen?.(hsk); }}>Im</button>}
      {hasExport && <button type="button" style={reqBadgeStyle(f.ex)} title={reqBadgeTitle("수출", f.ex)} onClick={(e) => { e.stopPropagation(); onOpen?.(hsk); }}>Ex</button>}
    </span>
  );
}
